import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "store/store";
import { CssBaseline } from "@mui/material";
import { localEnvironment } from "constants/globals";

const isInLocal = process.env.REACT_APP_ENV == localEnvironment;
const root = createRoot(document.getElementById("root") as HTMLElement);

const indexComponent = isInLocal ? (
  <React.StrictMode>
    <Provider store={store}>
      <CssBaseline />
      <App />
    </Provider>
  </React.StrictMode>
) : (
  <Provider store={store}>
    <CssBaseline />
    <App />
  </Provider>
);

root.render(indexComponent);

reportWebVitals();
